import './css.js';

async function init() {
    await import('../../assets/unify/plugins/back-to-top');
    await import('../../assets/unify/plugins/jquery-appear');
    //await import('../../assets/unify/plugins/smoothScroll');
    await import('../../assets/unify/plugins/jquery.parallax');
    await import('../../assets/unify/plugins/owl-carousel/owl-carousel/owl.carousel');
    await import('../../assets/unify/plugins/cube-portfolio/cubeportfolio/js/jquery.cubeportfolio');
    await import('../../assets/lib/master-slider/source/assets/js/masterslider.min');
    if(hasMasterSlider === 'true') {
        let slider = new MasterSlider();
        slider.setup('masterslider', {
            width: 1650,    // slider standard width
            height: 600,   // slider standard height
            fullwidth: true,
            view: "parallaxMask",
            autoplay: true
        });
        slider.control('arrows');
        slider.control('bullets');
        slider.control('thumblist', {autohide: false, dir: "v"});
    }

    const App = await import('../../assets/unify/js/app.js');
    const OwlCarousel = await import(/* webpackChunkName: "owlCarousel" */ '../../assets/unify/js/plugins/owl-carousel.js');
    $(document).ready(function () {
        App.init();
        App.initParallaxBg();
        App.initAnimateDropdown();
        OwlCarousel.initOwlCarousel();
    });

    $(function () {
        let winh = $(window).height();
        let winh_pic = winh - 157;
        $('.index_pic1').css('height', winh_pic);
        $('.index_pic2, .index_pic3, .index_pic4').css('height', winh_pic / 2);
        // var winw = $(window).width();
        // $('.sprow').css('width',winw);

        $('.index_pic1, .index_pic2, .index_pic3, .index_pic4').mouseenter(function () {
            $(this).addClass('in');
        });
        $('.index_pic1, .index_pic2, .index_pic3, .index_pic4').mouseleave(function () {
            $('.index_pic1, .index_pic2, .index_pic3, .index_pic4').removeClass('in');
        });
    });
}

init().then(async function () {
    let parsley = await import('parsleyjs');
    let text = await import('../../public/locales/'+locale+'/hotel.json');
    let Pikaday = await import('pikaday');
    let pikaI18n = {
        'zh-TW': {
            previousMonth: '上個月',
            nextMonth: '下個月',
            months: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
            weekdays: ['週日', '週一', '週二', '週三', '週四', '週五', '週六'],
            weekdaysShort: ['日', '一', '二', '三', '四', '五', '六'],
            dateFieldFormat: 'YYYY年 MM月 DD日'
        },
        'zh-CN': {
            previousMonth: '上个月',
            nextMonth: '下个月',
            months: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
            weekdays: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
            weekdaysShort: ['日', '一', '二', '三', '四', '五', '六'],
            dateFieldFormat: 'YYYY年 MM月 DD日'
        },
        'ja': {
            previousMonth: '先月',
            nextMonth: '来月',
            months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
            weekdays: ['日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日'],
            weekdaysShort: ['日', '月', '火', '水', '木', '金', '土'],
            dateFieldFormat: 'YYYY年 MM月 DD日'
        },
        'en': {
            previousMonth : 'Previous Month',
            nextMonth     : 'Next Month',
            months        : ['January','February','March','April','May','June','July','August','September','October','November','December'],
            weekdays      : ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
            weekdaysShort : ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'],
            dateFieldFormat: 'YYYY / MM / DD'
        },
        'ko': {
            previousMonth: '지난 달',
            nextMonth: '다음 달',
            months: ['일월', '이월', '삼월', '사월', '오월', '유월', '칠월', '팔월', '구월', '시월', '십일월', '십이월'],
            weekdays: ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일'],
            weekdaysShort: ['일', '월', '화', '수', '목', '금', '토'],
            dateFieldFormat: 'YYYY년 MM월 DD일'
        }
    };
    let dateFieldFormat = pikaI18n[locale].dateFieldFormat;
    let checkInDate = new Pikaday({
        format: dateFieldFormat,
        field: document.getElementById('datepicker-check-in'),
        trigger: document.getElementById('check-in-group'),
        i18n: pikaI18n[locale],
        keyboardInput: false,
        disableDayFn: function(dateField){
            let d = new Date();
            d.setDate(d.getDate() - 1);
            if(dateField <= d){
                return true;
            }
        },
        onSelect: function(){
            let checkInDateObj = checkInDate.getDate();
            let checkOutDateObj = checkOutDate.getDate();

            //快速訂房-租車類別的還車日調整
            if( hotelType === 'rentalcars' ){
                checkOutDate.setMinDate((new Date(checkInDateObj.getFullYear(), checkInDateObj.getMonth(), checkInDateObj.getDate())));
                if(checkOutDateObj === null || checkOutDateObj < checkInDateObj){
                    checkOutDate.setDate((new Date(checkInDateObj.getFullYear(), checkInDateObj.getMonth(), checkInDateObj.getDate())));
                    checkOutDate.show();
                }
            }else{
                checkOutDate.setMinDate((new Date(checkInDateObj.getFullYear(), checkInDateObj.getMonth(), checkInDateObj.getDate()+1)));
                if(checkOutDateObj === null || checkOutDateObj <= checkInDateObj){
                    checkOutDate.setDate((new Date(checkInDateObj.getFullYear(), checkInDateObj.getMonth(), checkInDateObj.getDate()+1)));
                    checkOutDate.show();
                }
            }
            document.getElementById('check-in-date').value = checkInDate.toString('YYYY-MM-DD');
        }
    });
    let checkOutDate = new Pikaday({
        format: dateFieldFormat,
        field: document.getElementById('datepicker-check-out'),
        trigger: document.getElementById('check-out-group'),
        i18n: pikaI18n[locale],
        keyboardInput: false,
        disableDayFn: function(dateField){
            let d = new Date();
            if(dateField <= d){
                return true;
            }
        },
        onSelect: function(){
            document.getElementById('check-out-date').value = checkOutDate.toString('YYYY-MM-DD');
        }
    });

    $('#fast-booking-form-submit').bind('click', function(event){
        event.preventDefault();
        let checkInDateInput = $('#datepicker-check-in').val();
        let checkOutDateInput = $('#datepicker-check-out').val();

        if(checkInDateInput.length <= 0){
            alert(text.SystemText.SelectDate);
            checkInDate.show();
            return false;
        }
        if(checkOutDateInput.length <= 0){
            alert(text.SystemText.SelectDate);
            checkOutDate.show();
            return false;
        }
        if(!$.isNumeric($('select[name="roomcount"]').val())){
            alert(text.SystemText.SelectQuantity);
            return false;
        }
        if((new Date(checkOutDate)) < (new Date(checkInDate))){
            alert(text.SystemText.GreaterThan);
            return false;
        }

        //快速訂房-租車類別的送出的還車日調整
        if( hotelType === 'rentalcars' ){
            let checkOutDateObj = checkOutDate.getDate();
            checkOutDate.setDate((new Date(checkOutDateObj.getFullYear(), checkOutDateObj.getMonth(), checkOutDateObj.getDate()+1)));
        }

        $('#fast-booking-form').submit();
    });

    //對使用者輸入的promo code進行檢查
    $('#promo-code-text').attr({
        'data-parsley-required': true,
        'data-parsley-pattern': '[A-Za-z0-9]+',
        'data-parsley-pattern-message': '僅可英文數字組合'
    });

    let validator = parsley.$element.find('#promo-code-form').parsley({
        errorsWrapper: '<div></div>',
        errorTemplate: '<span class="color-red" style="font-size: 10pt; color: #e74c3c;"></span>',
        errorsContainer: function (field) {
            return field.$element.closest('div').find('div.error-message');
        }
    });

    $('#promo-code-form-submit').bind('click', function(event){
        validator.validate();
        if (validator.isValid()) {
            $('#promo-code-form').submit();
        }
    });

    if($('#datepicker-check-in').val().length !== 0 && $('#check-in-date').val().length <= 0){
        document.getElementById('datepicker-check-in').value ='';
        document.getElementById('datepicker-check-out').value ='';
        $("#roomcount").val(1);
    }

    $(document).ready(function () {
        $('#autoNotice').get(0).click();
    });

    $('#Notice-remember').on('change', function () {
        $.ajax(urlPrefix + '/api/index/notice', {
            type: 'post',
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr('content')
            }
        });
    })
});



// WEBPACK FOOTER //
// ./webpack/index/entry.js